import Vue from 'vue'
import VueApollo from 'vue-apollo'

import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

Vue.use(VueApollo)

// HTTP connection to the API
const urlBase = process.env.VUE_APP_NODE_ENV === 'production' ? 'https://colimptex.kbe.ai/graphql' : 'https://colimptextest.kbe.ai/graphql'
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: urlBase
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

export default apolloProvider
